import { useCallback, useMemo } from 'react';
import { type TCTemplateRecord } from 'src/api/generated';
import { useTriggers } from 'src/modules/shared/hooks/api/automations/triggers';

export const useTemplateTriggers = (
  isOpen: boolean,
  selectedTemplate?: TCTemplateRecord | null
) => {
  const { triggers, loading: triggersLoading } = useTriggers(50, isOpen);

  const triggerDisplay = useCallback(
    (id?: string) => {
      if (!id) return '';
      const match = (triggers || []).find((t) => t.triggerId === id);
      return match?.name || id;
    },
    [triggers]
  );

  const selectedTrigger = useMemo(
    () =>
      triggers.find(
        (t) => String(t.triggerId) === selectedTemplate?.trigger?.id
      ),
    [triggers, selectedTemplate?.trigger?.id]
  );

  const selectedTriggerName = useMemo(() => {
    if (!selectedTemplate?.trigger?.id) return undefined;
    return triggerDisplay(selectedTemplate.trigger.id);
  }, [selectedTemplate?.trigger?.id, triggerDisplay]);

  return {
    triggers,
    triggersLoading,
    triggerDisplay,
    selectedTrigger,
    selectedTriggerName,
  };
};
